import * as Sentry from "@sentry/react";

// Transient network failures (flaky mobile/WebView connectivity) reject with a
// generic TypeError. Retry a couple of times before giving up.
const MAX_ATTEMPTS = 3;
const RETRY_DELAY_MS = 300;

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const fetchFullSiteData = async function (domain, shopId) {
    let queryString = "";
    if (domain !== "") {
        queryString = `?domain=${domain}`;
    }
    if (shopId !== "") {
        queryString = queryString + `&shopId=${shopId}`;
    }

    const requestOptions = {
        method: "GET",
    };

    const url = `${import.meta.env.VITE_API_URL}/bookings/config${queryString}`;

    let lastError;
    for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
        try {
            const response = await fetch(url, requestOptions);
            const data = await response.json();
            return data;
        } catch (error) {
            lastError = error;
            if (attempt < MAX_ATTEMPTS) {
                await delay(RETRY_DELAY_MS * attempt);
            }
        }
    }

    // Exhausted all attempts — report once and surface to the caller.
    Sentry.captureException(lastError, {
        tags: { source: "fetchFullSiteData" },
        extra: { domain, shopId, attempts: MAX_ATTEMPTS },
    });
    throw lastError;
};
